@if (customer && (name || accountNumber)) {
  <div class="selected-customer" aria-label="Selected customer">
    <mat-icon class="selected-customer__icon" aria-hidden="true">person</mat-icon>
    <!-- Account number first, then name — the order Step 1's "Account Number - Customer Name" column uses. -->
    @if (accountNumber) {
      <div class="selected-customer__field">
        <span class="selected-customer__label">Account #</span>
        <span class="selected-customer__value selected-customer__account">{{ accountNumber }}</span>
      </div>
    }
    @if (name) {
      <div class="selected-customer__field">
        <span class="selected-customer__label">Customer</span>
        <span class="selected-customer__value selected-customer__name">{{ name }}</span>
      </div>
    }
    @if (canChange) {
      <button type="button" class="selected-customer__change" (click)="changeCustomer.emit()">change</button>
    }
  </div>
}
